import React from 'react';
import { Table } from '@alifd/next';
import { Icon, Message } from '@b-design/fusion';
import { DragDropContext, DragSource, DropTarget } from 'react-dnd';
import { Tooltip } from 'antd';
import HTML5Backend from 'react-dnd-html5-backend';
import classnames from 'classnames';
import Confirm from '@/components/Confirm';
import Requests from '@/services/request';
import moment from 'moment';
import ColorTags from '@/components/ColorTags';
import { getCookie } from '@/utils';
import $i18n from '@/i18n';
import './index.less';

const { SelectionRow } = Table;
let dragingIndex = -1;
function MyRow(props) {
  const {
    isDragging,
    isOver,
    connectDragSource,
    connectDropTarget,
    moveRow,
    className,
    ...others
  } = props;
  const opacity = isDragging ? 0 : 1;
  const style = { ...others.style, cursor: 'move' };
  const cls = classnames({
    [className]: className,
    'drop-over-upward': isOver && others.index < dragingIndex,
    'drop-over-downward': isOver && others.index > dragingIndex,
  });
  return (
    <SelectionRow
      {...others}
      style={{ ...style, ...{ opacity } }}
      className={cls}
      wrapper={(row) => connectDragSource(connectDropTarget(row))}
    />
  );
}
const NewRow = DropTarget(
  'row',
  {
    drop(props, monitor) {
      const dragIndex = monitor.getItem().index;
      const hoverIndex = props.index;
      if (dragIndex === hoverIndex) {
        return;
      }
      props.moveRow(dragIndex, hoverIndex);
      monitor.getItem().index = hoverIndex;
    },
  },
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  }),
)(
  DragSource(
    'row',
    {
      beginDrag: (props) => {
        dragingIndex = props.index;
        return {
          id: props.record[props.primaryKey],
          index: props.rowIndex,
        };
      },
    },
    (connect, monitor) => ({
      connectDragSource: connect.dragSource(),
      isDragging: monitor.isDragging(),
    }),
  )(MyRow),
);
class InnerTable extends React.Component {
  constructor(props) {
    super(props);

    this.moveRow = (dragIndex, hoverIndex) => {
      const { initData } = this.props;
      const dragRow = this.state.dataSource[dragIndex];
      // 排序接口
      Requests.post('/rest/intercnn/space/category/reorder', {
        id: dragRow.id,
        order: hoverIndex,
      }).then((res) => {
        if (res) {
          initData();
        }
      });
      const dataSource = [...this.state.dataSource];
      dataSource.splice(dragIndex, 1);
      dataSource.splice(hoverIndex, 0, dragRow);
      this.setState({
        dataSource,
      });
    };
    this.state = {
      dataSource: [...props.dataSource],
    };
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.dataSource &&
      JSON.stringify(nextProps.dataSource) !== JSON.stringify(this.state.dataSource)
    ) {
      this.setState({ dataSource: [...nextProps.dataSource] });
    }
  }
  render() {
    const { excludeProvider, ...restProps } = this.props;
    const tableProps = {
      ...restProps,
      dataSource: this.state.dataSource,
      rowProps: (props, index) => ({
        index,
        moveRow: this.moveRow,
      }),
      components: {
        Row: NewRow,
      },
    };
    return <Table {...tableProps} />;
  }
}
class SortableTable extends React.Component {
  render() {
    const ComponentName = DragDropContext(HTML5Backend)(InnerTable);
    return <ComponentName {...this.props} key={Math.random() * 1000000} />;
  }
}

class DragList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: [],
    };
  }
  renderIcon = () => {
    return (
      <div>
        <Icon type="draggable" />
      </div>
    );
  };

  deleteCategory = async (v) => {
    const res = await Requests.post('/rest/intercnn/space/category/delete', { id: v.id });
    if (res) {
      Message.success({
        title: $i18n.get({
          id: 'aopf.pages.invitation.spaces.message.deleteSuccess',
          dm: '删除成功',
        }),
      });
      this.props.initData();
    }
  };

  renderOperate = (value, index, record) => {
    return (
      <div className='operate-action'>
        <a
          className="operate"
          onClick={() => {
            this.props.setVisible(true);
            this.props.setDetailDataSource(record);
            this.props.setEditStatus('edit');
          }}
        >
          <Icon type="edit--outline" style={{ marginRight: '9px' }} />
          {$i18n.get({
            id: 'aopf.pages.miniapp.detail.info.Edit.btn',
            dm: '编辑',
          })}
        </a>
        <Confirm
          trigger={
            <a className="operate">
              <Icon type="trash-can--outline" style={{ marginRight: '9px' }} />
              {$i18n.get({
                id: 'aopf.pages.miniapp.detail.info.btn.Delete',
                dm: '删除',
              })}
            </a>
          }
          dialogTitle={$i18n.get({
            id: 'aopf.pages.miniAppStore.drawer.delete',
            dm: '删除类目',
          })}
          dialogContent={$i18n.get({
            id: 'aopf.pages.miniAppStore.drawer.delete.desc',
            dm: '确定删除该类目？',
          })}
          width={400}
          onClick={this.deleteCategory.bind(null, record)}
        />
      </div>
    );
  };

  renderName = (value) => {
    return $i18n.language === 'zh-CN' ? (
      <Tooltip title={value.zh_CN}>
        <div className="drag-categoryName">{value.zh_CN}</div>
      </Tooltip>
    ) : (
      <Tooltip title={value.en_US}>
        <div className="drag-categoryName">{value.en_US}</div>
      </Tooltip>
    );
  };

  renderTime = (v) => {
    return moment(v).format('YYYY-MM-DD HH:mm:ss');
  };

  renderStatus = (v) => {
    return (
      <ColorTags
        tagTheme={v === 'ENABLE' ? 'green' : 'grey'}
        name={v === 'ENABLE' ? $i18n.get({
          id: 'aopf.pages.miniAppStore.setting.category.list.enable',
          dm: '已启用',
        }) : $i18n.get({
          id: 'aopf.pages.miniAppStore.setting.category.list.unEnable',
          dm: '未启用',
        })}
      />
    );
  };

  render() {
    return (
      <div className="dragList">
        <SortableTable
          dataSource={this.props.dataSource}
          hasBorder={false}
          loading={this.props.loading}
          initData={this.props.initData}
        >
          <Table.Column title="" dataIndex=" " cell={this.renderIcon} width={50} />
          <Table.Column
            title={$i18n.get({
              id: 'aopf.pages.miniAppStore.drawer.categoryName',
              dm: '类目名称',
            })}
            dataIndex="name"
            cell={this.renderName}
          />
          <Table.Column
            title={$i18n.get({
              id: 'aopf.pages.miniAppStore.drawer.categoryID',
              dm: '类目ID',
            })}
            dataIndex="id"
          />
          <Table.Column
            title={$i18n.get({
              id: 'aopf.pages.miniAppStore.list.column.updateTime',
              dm: '更新时间',
            })}
            dataIndex="gmtModified"
            cell={this.renderTime}
          />
          <Table.Column
            title={$i18n.get({
              id: 'aopf.pages.channel.channelList.columns.status',
              dm: '状态',
            })}
            dataIndex="status"
            cell={this.renderStatus}
          />
          <Table.Column
            title={$i18n.get({
              id: 'aopf.pages.list.Operation',
              dm: '操作',
            })}
            cell={this.renderOperate}
          />
        </SortableTable>
      </div>
    );
  }
}

export default DragList;
